import React, { useEffect, useState } from "react";
import axiosService from "../../utils/axios.service";
import { Container, Row, Col } from "react-bootstrap";
import ChildOrder from "./ChildOrder"
import styles from "../../styles/popupInfor.module.css"

var userAdmin = JSON.parse(localStorage.getItem("user_info"))
const Transaction = ({customer}) => {
  const [orders, setOrders] = useState([])
  const getData = async () => {
    const res = await axiosService("api/customer/get-data-made-order/"+customer.id + "?role="+ userAdmin.role, "GET");
    const { data } = res
    if (data.code === 200) {
      const { dataMadeOrder } = data.data
      setOrders(dataMadeOrder.Data)
    }
  }
  useEffect(() => {
    getData()
  }, [])
  return (
    <>
      <Container className={styles.scrollTransaction}>
        {orders.length > 0
          ? <>
            {orders.map((x, i) => {
              return <ChildOrder key={i} order={x} customer={customer}  />
            })}
          </>
          : "Không có thông tin"
        }
      </Container>
    </>
  )
}
export default Transaction